import { Injectable } from '@angular/core';

import {
  mimeBlacklist,
  mimeWhitelist
} from '@digital-platform/attachments/domain';
import { FileValidatorService } from '@digital-platform/shared/ui';

@Injectable({
  providedIn: 'root'
})
export class AttachmentValidatorService extends FileValidatorService {
  protected mimeBlacklist = mimeBlacklist;
  protected mimeWhitelist = mimeWhitelist;
}
